/**
 * User info component that displays current admin user information
 */
import React, { useState, useEffect } from 'react';
import { authService, AdminUser } from '../../utils/auth';

interface UserInfoProps {
  className?: string;
  showRole?: boolean;
  showEmail?: boolean;
}

export const UserInfo: React.FC<UserInfoProps> = ({ 
  className = '',
  showRole = true,
  showEmail = false
}) => {
  const [user, setUser] = useState<AdminUser | null>(null);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    setUser(currentUser);
  }, []);

  if (!user) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Avatar */}
      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-blue-700 text-white flex items-center justify-center text-xs font-semibold shadow-sm">
        {(user.full_name || `${user.first_name} ${user.last_name}`).charAt(0).toUpperCase()}
      </div>
      
      {/* User details */}
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-semibold text-gray-900 truncate">
          {user.full_name || `${user.first_name} ${user.last_name}`}
        </span>
        {showEmail && (
          <span className="text-xs text-gray-500 truncate">
            {user.email}
          </span>
        )}
        {showRole && (
          <span className={`text-xs font-medium truncate ${
            user.is_super_admin ? 'text-purple-600' : 'text-blue-600'
          }`}>
            {user.is_super_admin ? 'Super Admin' : user.role.charAt(0).toUpperCase() + user.role.slice(1)}
          </span>
        )}
      </div>
    </div>
  );
};